// extracted by mini-css-extract-plugin
export var container = "key-figure-row-module--container--29333";
export var transformContainer = "key-figure-row-module--transformContainer--8798a";